import { c as _c } from "react/compiler-runtime";
import { SortSelector } from "@components/common/sort-selector";
import { useEffect } from "react";
/**
 * Generic sort base component used by the members, team members and groups sort selectors.
 */
export function MembersSortBase(t0) {
  const $ = _c(14);
  const {
    sortBy,
    setSortBy,
    sortOptions,
    sortByMap,
    defaultSortBy,
    getSortBy,
    subjectType
  } = t0;
  const sortItem = sortByMap[sortBy];
  const isSelectedFieldVisible = !!(sortItem && sortOptions[sortItem.field]);
  const validSortBy = isSelectedFieldVisible ? sortBy : defaultSortBy;
  let t1;
  let t2;
  if ($[0] !== defaultSortBy || $[1] !== isSelectedFieldVisible || $[2] !== setSortBy || $[3] !== sortBy) {
    t1 = () => {
      if (!isSelectedFieldVisible && sortBy !== defaultSortBy) {
        setSortBy(defaultSortBy);
      }
    };
    t2 = [isSelectedFieldVisible, sortBy, defaultSortBy, setSortBy];
    $[0] = defaultSortBy;
    $[1] = isSelectedFieldVisible;
    $[2] = setSortBy;
    $[3] = sortBy;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== getSortBy || $[7] !== setSortBy) {
    t3 = function handleSortChange(newSortItem) {
      setSortBy(getSortBy(newSortItem));
    };
    $[6] = getSortBy;
    $[7] = setSortBy;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSortChange = t3;
  const t4 = sortByMap[validSortBy];
  let t5;
  if ($[9] !== handleSortChange || $[10] !== sortOptions || $[11] !== subjectType || $[12] !== t4) {
    t5 = <SortSelector sortOptions={sortOptions} sortItem={t4} setSortItem={handleSortChange} subjectType={subjectType} />;
    $[9] = handleSortChange;
    $[10] = sortOptions;
    $[11] = subjectType;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}